<template>
  <div class="personalReport">
    <div class="title">
      年费用户专属服务<Back/>
    </div>

    <el-form label-width="130px" label-position="left">
      <el-form-item label="默认授权与否：">
        <div style="display:flex;flex-direction: column;">
          <el-checkbox
            :label="null"
            v-model="checkbox.null"
            @change="handleDealChange($event, null)"
            >每次都询问</el-checkbox
          >
          <el-checkbox
            :label="true"
            v-model="checkbox.true"
            @change="handleDealChange($event, true)"
            >每次都同意</el-checkbox
          >
          <el-checkbox
            :label="false"
            v-model="checkbox.false"
            @change="handleDealChange($event, false)"
            >每次都拒绝</el-checkbox
          >
        </div>
      </el-form-item>
      <el-form-item label="默认授权报告：">
        <el-select v-model="form.reportId">
          <el-option
            v-for="item in reportList"
            :key="item.id"
            :value="item.id"
            :label="item.name"
            >{{ item.name }}</el-option
          >
        </el-select>
      </el-form-item>
      <el-form-item label="默认查验有效期：">
        <div class="expirationDay">
          <el-input v-model="form.expirationDay"></el-input>
          <span>天</span>
        </div>
      </el-form-item>
    </el-form>
    <el-checkbox v-model="form.oldDataDeal"
      ><span style="color:#6E6E6E"
        >按照此次设置处理当前未处理的所有查验申请</span
      ></el-checkbox
    >

    <button class="btn_add" @click="handleSet">确认设置</button>
  </div>
</template>

<script>
import { reportList } from "@/api/report";
import { defaultConfig, defaultConfigFind } from "@/api/inspection";
import Back from '../../../components/Back.vue';
export default {
  components: { Back },
  data() {
    return {
      tableData: [
        {
          date: "2016-05-03",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-02",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-08",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-06",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        },
        {
          date: "2016-05-07",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          zip: 200333
        }
      ],
      list: [
        {
          date: "2022-04-07 17:13",
          dataSource: "阿里巴巴",
          phone: "18988889999",
          status: "待处理"
        },
        {
          date: "2022-04-07 17:13",
          dataSource: "阿里巴巴",
          phone: "18988889999",
          status: "待处理"
        }
      ],
      reportList: [],
      form: {
        deal: null,
        expirationDay: 0,
        oldDataDeal: false,
        reportId: undefined
      },
      checkbox: {
        null: false,
        true: false,
        false: false
      }
    };
  },
  created() {
    this.getReportList();
    this.getDefaultConfig();
  },
  methods: {
    getDefaultConfig() {
      defaultConfigFind().then(res => {
        if (res.data.d) {
          this.form = res.data.d;
          this.checkbox[this.form.deal] = true;
        }
      });
    },
    handleDetail() {
      this.$router.push("credentialsDetail");
    },
    async getReportList() {
      await reportList({ current: 1, size: 999 }).then(res => {
        this.reportList = res.data.d.records;
      });
    },
    handleDealChange(val, flag) {
      switch (flag) {
        case null:
          this.checkbox.null = true;
          this.checkbox.true = false;
          this.checkbox.false = false;
          break;
        case true:
          this.checkbox.null = false;
          this.checkbox.true = true;
          this.checkbox.false = false;
          break;
        case false:
          this.checkbox.null = false;
          this.checkbox.true = false;
          this.checkbox.false = true;
          break;
        default:
          break;
      }
    },
    handleSet() {
      let payload = Object.assign({}, this.form);
      Object.keys(this.checkbox).forEach(key => {
        console.log(key);
        if (this.checkbox[key]===true) {
          payload.deal = key === "null" ? null : key === "true" ? true : false;
        }
      });
      // payload.deal =
      console.log(payload);
      // console.log(typeof payload.deal);

      defaultConfig(payload).then(res => {
        console.log(res);
        if (res.data.c === 200) {
          this.$message.success("设置成功");
          setTimeout(() => {
            this.$router.go(-1);
          }, 1000);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.personalReport {
  display: flex;
  margin-top: 39px;
  flex: 1;
  margin-bottom: 70px;
  background: #fff;
  margin-left: 17px;
  padding: 38px 41px 60px 40px;
  flex-direction: column;
  min-height: 702px;
  box-sizing: border-box;
  // .el-table th.el-table__cell {
  //   background-color: #f0f2f5;
  // }
  .reportInfo {
    padding: 36px 45px;
    display: flex;
    background: #f0f2f5;
    border-radius: 2px;
    justify-content: space-between;
    line-height: 27px;
    font-size: 14px;
    margin-top: 11px;
    margin-bottom: 32px;
    color: #6e6e6e;
  }
  .title {
    margin-bottom: 22px;
    font-weight: bold;
  }
  .detail {
    color: #338ff7;
  }
  .btns {
    display: flex;
    align-items: center;
    .btn_primary {
      background: #3a61b1;
      color: #fff;
      border: 0;
      outline: none;
      width: 77.7px;
      border-radius: 15px;
      height: 30px;
    }
    .btn_primary_plain {
      color: #3a61b1;
      background: #f0f2f5;
      border: 1px solid #3a61b1;
      outline: none;
      width: 77.7px;
      border-radius: 15px;
      height: 30px;
    }
  }
  .btn_default {
    width: 126px;
    height: 39px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 20px;
  }
  .dataTable {
    margin-top: 33px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tabList {
      .tabItem {
        color: #6e6e6e;
        font-size: 16px;
        margin-right: 42px;
      }
      .active {
        color: #3a61b1;
      }
    }
  }
  .list {
    margin-top: 18px;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    color: #6e6e6e;
    .item {
      padding: 30px 32px 35px 34px;
      line-height: 29px;
      border: 1px solid #f1f1f1;
      margin-bottom: 19px;
      display: flex;
      justify-content: space-between;
      &:last-child {
        margin-bottom: 0;
      }
      .btns {
        color: #338ff7;
        flex-direction: column;
        span {
          cursor: pointer;
        }
      }
      .status {
        color: #ff5129;
      }
      .r16 {
        color: #ff5129;
        font-size: 16px;
      }
    }
  }
  .btn_add {
    width: 142px;
    height: 41px;
    // background: linear-gradient(43deg, #f06c30, #ff4734, #fe6151);
    background: #e5c7a3;
    color: #653e12;
    font-size: 16px;
    font-weight: 500;
    border-radius: 21px;
    border: 0;
    margin-top: 34px;
  }
  .expirationDay {
    position: relative;
    width: 178px;
    display: flex;
    // >>> .el-input {
    //   .el-input__inner {
    //     border: 1px solid #fce6d4 !important;
    //   }
    // }

    span {
      position: absolute;
      right: 23px;
    }
  }
  >>> .el-input__inner {
    border: 1px solid #fce6d4 !important;
  }
  >>> .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #3b393c;
    border-color: #3b393c;
  }
  >>> .el-checkbox__inner {
    width: 20px;
    height: 20px;
    border: 2px solid #fce6d4;
    border-radius: 4px;
  }
  >>> .el-checkbox__inner::after {
    height: 9px;
    left: 5px;
    position: absolute;
    top: 1px;
    width: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/reportCheck/authReportDetail.vue